/** @jsx jsx */
import React, { useState, useMemo } from 'react';
import { jsx } from 'theme-ui';
import { FontsList } from './fonts-list';

export const Landing = ({ blocks }) => {
  return <FontsList blocks={blocks} />;
};
